import { render, staticRenderFns } from "./projectManageForm.vue?vue&type=template&id=5b860306&scoped=true&"
import script from "./projectManageForm.vue?vue&type=script&lang=js&"
export * from "./projectManageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b860306",
  null
  
)

export default component.exports